<template>
  <fragment>
    <b-row v-if="data.specialties != null">
      <b-col
        cols="6"
        lg="7"
        class="d-flex justify-content-end font-weight-bold v2_font_size_18 pr-lg-1"
      >
        {{ data.specialties }}
      </b-col>
      <b-col
        cols="6"
        lg="5"
        class="d-flex justify-content-start align-items-center pl-lg-1"
        >specialties</b-col
      >
    </b-row>
    <b-row v-if="data.subspecialties != null">
      <b-col
        cols="6"
        lg="7"
        class="d-flex justify-content-end font-weight-bold v2_font_size_18 pr-lg-1"
      >
        {{ data.subspecialties }}
      </b-col>
      <b-col
        cols="6"
        lg="5"
        class="d-flex justify-content-start align-items-center pl-lg-1"
        >subspecialties</b-col
      >
    </b-row>
    <template v-if="data.users != null">
      <b-row v-for="(value, name) in data.users" :key="name">
        <b-col
          cols="6"
          lg="7"
          class="d-flex justify-content-end font-weight-bold v2_font_size_18 pr-lg-1"
        >
          {{ value.number_of_society_users }} /
          {{ value.number_of_total_users }}
        </b-col>
        <b-col
          cols="6"
          lg="5"
          class="d-flex justify-content-start align-items-center pl-lg-1"
          >{{ name.toLowerCase() }}</b-col
        >
      </b-row>
    </template>
  </fragment>
</template>

<script>
export default {
  name: 'SpecialtiesStatistics',
  props: {
    data: Object,
  },
};
</script>

<style scoped></style>
